__turbopack_context__.v({
  "className": "noedisplayregular_e27fbb12-module__kKlAza__className",
  "variable": "noedisplayregular_e27fbb12-module__kKlAza__variable",
});
